import { useEffect } from "react";
import { useMutation } from "react-query";
import { deleteDocument } from "../../../apis/private.api";
import { useUser } from "../../../hooks/User";
import { ToggleableCardWrapper } from "../ToggleableCardWrapper";
import styled from "styled-components";

const DocumentText = styled.span`
  &:hover{
    cursor:pointer;
    text-decoration: underline;
  }
`;

export interface CardDocumentProps {
  documentName: string;
  documentUrl: string;
}

export const CardDocument = (props: CardDocumentProps) => {

  const {refreshUserSession, getDataByAttributeName} = useUser();
  const id = getDataByAttributeName("id");

  const {mutate, isLoading, isSuccess} = useMutation(
    "deleteDocument", () => deleteDocument(id)
  );

  const handleDownload = () => {
    let a = document.createElement('a');
    a.href = props.documentUrl;
    a.download = props.documentName;
    a.target = "_blank";
    a.click();
    a.remove();
  }

  useEffect(() => {
    isSuccess && refreshUserSession()
  }, [isSuccess])

  return (
    <ToggleableCardWrapper handleDelete={mutate} isDeleting={isLoading}>
      <DocumentText onClick={handleDownload}>
        {props.documentName}
      </DocumentText>
    </ToggleableCardWrapper>
  )
}